import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  label: string;
  value: string | number;
  icon?: LucideIcon;
  hint?: string;
  tone?: "default" | "primary" | "success" | "warning" | "danger";
  className?: string;
}

const TONE_CLASSES: Record<NonNullable<StatCardProps["tone"]>, string> = {
  default: "text-foreground",
  primary: "text-primary",
  success: "text-emerald-400",
  warning: "text-amber-400",
  danger: "text-destructive",
};

export default function StatCard({
  label,
  value,
  icon: Icon,
  hint,
  tone = "default",
  className,
}: StatCardProps) {
  return (
    <div
      className={cn(
        "relative rounded-2xl border border-border/50 bg-card/70 backdrop-blur-xl p-3 sm:p-4",
        "hover:border-primary/30 transition-colors",
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <p className="text-[10px] sm:text-[11px] font-medium uppercase tracking-wider text-muted-foreground truncate">
          {label}
        </p>
        {Icon && <Icon className="w-3.5 h-3.5 text-muted-foreground shrink-0" />}
      </div>
      <p
        className={cn(
          "font-heading font-bold text-lg sm:text-xl tabular-nums truncate",
          TONE_CLASSES[tone],
        )}
      >
        {value}
      </p>
      {hint && (
        <p className="text-[10px] text-muted-foreground mt-0.5 truncate">{hint}</p>
      )}
    </div>
  );
}